import script from "./CompanyProductCreateView.vue?vue&type=script&setup=true&lang=js"
export * from "./CompanyProductCreateView.vue?vue&type=script&setup=true&lang=js"

import "./CompanyProductCreateView.vue?vue&type=style&index=0&id=0d68bde8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d68bde8"]])

export default __exports__